import { createFileRoute } from "@tanstack/react-router"
import { AdminSupportPage } from "@/components/pages/AdminSupportPage"

// `/admin/support` — the live support inbox. Guard inherited from the parent layout.
export const Route = createFileRoute(`/_authenticated/admin/support`)({
  component: AdminSupportPage,
  ssr: false,
})
